<template>
  <div>
    <div :class="['fire-detail-container', dialogVisible ? 'show' : '']" v-loading="drawLoading" element-loading-text="详情加载中" element-loading-spinner="el-icon-loading">
      <div class="container__header" v-if="alarmDetail.multiAlarmType != '2'">
        <div class="slot-title" :title="alarmDetail.alarmTitle">
          {{ alarmDetail.alarmTitle }}
        </div>
      </div>
      <!-- 两点报警 -->
      <div class="container__header" v-else>
        <div class="slot-title" style="color: red">【两点报警】</div>
      </div>
      <el-scrollbar class="container__scrollbar">
        <div v-if="alarmDetail.subSystem == '13'" style="padding: 0 15px 10px">
          <img class="noImg" style="height: 160px; width: 100%" src="../../../common/assets/images/electricalFire.png" />
        </div>
        <div class="container__scrollbar__content">
          <div style="display: flex; margin-bottom: 12px">
            <div v-for="item in tabs" :key="item.value" :class="['tab', activeName === item.value ? 'active' : '']" @click="handleTabsChange(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="content-list" v-show="activeName === 0">
            <template v-if="!rowClick.alarmId">
              <div class="content-list__item">
                <div class="content-list__label">告警类型</div>
                <div class="content-list__value">
                  {{ alarmDetail.commonAlarmTypeLabel }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">设备告警类型</div>
                <div class="content-list__value">
                  {{ alarmDetail.alarmTypeLabel }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">告警时间</div>
                <div class="content-list__value">
                  {{ formatterTimeCopy(alarmDetail.alarmTime) }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">告警级别</div>
                <div class="content-list__value">
                  {{ alarmLevel(alarmDetail.alarmLevel) }}
                </div>
              </div>
              <!-- <div class="content-list__item" v-if="alarmDetail.alarmType == '40132'">
                <div class="content-list__label">当前水位</div>
                <div class="content-list__value">
                  {{ alarmDetail.currentValue }} （m）
                </div>
              </div>
              <div class="content-list__item" v-if="alarmDetail.alarmType == '40132'">
                <div class="content-list__label">水位异常范围</div>
                <div class="content-list__value">{{ alarmDetail.limitValue }} （m）</div>
              </div> -->
              <div class="content-list__item" v-if="alarmDetail.subSystem == '13'">
                <div class="content-list__label">告警描述</div>
                <div class="content-list__value">{{ alarmDetail.desc }}</div>
              </div>
              <div class="content-list__item" v-else>
                <div class="content-list__label">告警描述</div>
                <div class="content-list__value">
                  {{ editDescInfo }}
                  <!-- <el-input type="textarea" v-model="editDescInfo" /> -->
                </div>
              </div>
              <template v-if="alarmDetail.subSystem !== '13'">
                <div class="content-list__item">
                  <div class="content-list__label">主机类型</div>
                  <div class="content-list__value">
                    {{ alarmDetail.deviceType | dic("SENU087") }}
                    <span v-if="
                        alarmDetail.deviceType ||
                        alarmDetail.parentFactoryName ||
                        alarmDetail.factoryName
                      ">(</span>
                    {{
                      alarmDetail.subDeviceMark
                        ? alarmDetail.parentFactoryName
                        : alarmDetail.factoryName
                    }}
                    <span v-if="
                        alarmDetail.deviceType ||
                        alarmDetail.parentFactoryName ||
                        alarmDetail.factoryName
                      ">)</span>
                  </div>
                </div>
                <div class="content-list__item">
                  <div class="content-list__label">主机名称</div>
                  <div class="content-list__value">
                    {{
                      alarmDetail.subDeviceMark
                        ? alarmDetail.parentDeviceName
                        : alarmDetail.deviceName
                    }}
                    <!-- <span
                      v-if="
                        alarmDetail.parentDeviceName ||
                        alarmDetail.deviceName ||
                        alarmDetail.parentThirdAlarmDevId
                      "
                      >(</span
                    >
                    {{ alarmDetail.parentThirdAlarmDevId }}
                    <span
                      v-if="
                        alarmDetail.parentDeviceName ||
                        alarmDetail.deviceName ||
                        alarmDetail.parentThirdAlarmDevId
                      "
                      >)</span
                    > -->
                  </div>
                </div>
                <div class="content-list__item" v-if="alarmDetail.subDeviceMark">
                  <div class="content-list__label">部件名称</div>
                  <div class="content-list__value">
                    {{ alarmDetail.deviceName }}
                    <!-- <span
                      v-if="
                        alarmDetail.componentThirdAlarmDevId && alarmDetail.deviceName
                      "
                      >
                      (</span
                    >
                    {{ alarmDetail.componentThirdAlarmDevId }}
                    <span
                      v-if="
                        alarmDetail.componentThirdAlarmDevId && alarmDetail.deviceName
                      "
                      >)</span
                    > -->
                  </div>
                </div>
                <div class="content-list__item" v-if="alarmDetail.subDeviceMark">
                  <div class="content-list__label">部件类型</div>
                  <div class="content-list__value">
                    {{ alarmDetail.subDeviceMark | dic("SENU094") }}
                  </div>
                </div>
                <div class="content-list__item" v-if="alarmDetail.subDeviceMark">
                  <div class="content-list__label">设备Mac地址</div>
                  <div class="content-list__value">
                    {{ alarmDetail.deviceMacAddr }}
                  </div>
                </div>
                <div class="content-list__item" v-if="alarmDetail.commonAlarmType == '4001'">
                  <div class="content-list__label">报警</div>
                  <div class="content-list__value">
                    {{ alarmType(alarmDetail.multiAlarmType) }}
                  </div>
                </div>
                <div class="content-list__item">
                  <div class="content-list__label">报警所在位置</div>
                  <div class="content-list__value">
                    {{ alarmDetail.buildingName }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="content-list__item">
                  <div class="content-list__label">主机类型</div>
                  <div class="content-list__value">
                    {{ rowClick.deviceType | dic("SENU087")
                    }}<span v-if="
                        rowClick.deviceType ||
                        rowClick.parentFactoryName ||
                        rowClick.factoryName
                      ">(</span>
                    {{
                      rowClick.subDeviceMark
                        ? rowClick.parentFactoryName
                        : rowClick.factoryName
                    }}
                    <span v-if="
                        rowClick.deviceType ||
                        rowClick.parentFactoryName ||
                        rowClick.factoryName
                      ">)</span>
                  </div>
                </div>
                <div class="content-list__item" v-if="rowClick.subSystem != '13'">
                  <div class="content-list__label">主机名称</div>
                  <div class="content-list__value">
                    {{
                      rowClick.subDeviceMark
                        ? rowClick.parentDeviceName
                        : rowClick.deviceName
                    }}
                    <span v-if="
                        rowClick.parentDeviceName ||
                        rowClick.deviceName ||
                        rowClick.parentThirdAlarmDevId
                      ">(</span>
                    {{ rowClick.parentThirdAlarmDevId }}
                    <span v-if="
                        rowClick.parentDeviceName ||
                        rowClick.deviceName ||
                        rowClick.parentThirdAlarmDevId
                      ">)</span>
                  </div>
                </div>
                <div class="content-list__item">
                  <div class="content-list__label">部件名称</div>
                  <div class="content-list__value">
                    {{ rowClick.deviceName }}
                    <span v-if="rowClick.componentThirdAlarmDevId && rowClick.deviceName">(</span>
                    {{ rowClick.componentThirdAlarmDevId }}
                    <span v-if="rowClick.componentThirdAlarmDevId && rowClick.deviceName">)</span>
                  </div>
                </div>
                <div class="content-list__item" v-if="rowClick.subDeviceMark">
                  <div class="content-list__label">部件类型</div>
                  <div class="content-list__value">
                    {{ rowClick.subDeviceMark | dic("SENU094") }}
                  </div>
                </div>
                <div class="content-list__item">
                  <div class="content-list__label">报警所在位置</div>
                  <div class="content-list__value">
                    {{ rowClick.buildingName }}
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="content-list__item">
                <div class="content-list__label">告警类型</div>
                <div class="content-list__value">
                  {{ rowClick.commonAlarmTypeLabel }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">设备告警类型</div>
                <div class="content-list__value">
                  {{ rowClick.alarmTypeLabel }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">告警时间</div>
                <div class="content-list__value">
                  {{ formatterTimeCopy(rowClick.alarmTime) }}
                </div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">告警级别</div>
                <div class="content-list__value">
                  {{ alarmLevel(rowClick.alarmLevel) }}
                </div>
              </div>
              <div class="content-list__item" v-if="alarmDetail.subSystem == '13'">
                <div class="content-list__label">告警描述</div>
                <div class="content-list__value">{{ rowClick.desc }}</div>
              </div>
              <div class="content-list__item" v-else>
                <div class="content-list__label">告警描述</div>
                <div class="content-list__value">
                  <span v-if="rowClick.buildingName">在{{ rowClick.buildingName }}位置,{{ rowClick.subDeviceMark }}上报
                    <span v-if="rowClick.commonAlarmType" :class="showColor(rowClick.commonAlarmType)">{{ rowClick.commonAlarmTypeLabel }}</span>
                  </span>
                </div>
              </div>
            </template>
            <div @click="isExpand = !isExpand">
              <span style="color: #2a65ff; cursor: pointer">楼栋基本信息</span>
              <el-button type="text" style="
                  margin-right: 25px;
                  font-size: 16px;
                  margin-top: 7px;
                  color: #2a65ff;
                " :class="[
                  'iconfont-lunan icon-lunan-xiaosanjiaodown',
                  isExpand ? 'icon-transform' : '',
                ]">
              </el-button>
            </div>
            <template v-if="isExpand">
              <div class="content-list__item">
                <div class="content-list__label">楼栋管理员</div>
                <div class="content-list__value">{{ buildingPerson }}</div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">安全员</div>
                <div class="content-list__value">{{ securityPersonnel }}</div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">备用安全员</div>
                <div class="content-list__value">{{ alternatePersonnel }}</div>
              </div>
              <div class="content-list__item">
                <div class="content-list__label">值班主机</div>
                <div class="content-list__value">
                  {{ alarmDetail.officePhone }}
                </div>
              </div>
            </template>
            <el-table :data="relationList" v-if="alarmDetail.multiAlarmType == '2'" style="width: 100%" highlight-current-row @row-click="alarmRowClick" max-height="300">
              <el-table-column type="index" label="序号" width="50"> </el-table-column>
              <el-table-column prop="alarmName" label="告警名称" width="180">
              </el-table-column>
              <el-table-column prop="alarmTime" label="告警时间" :formatter="formatterTime">
              </el-table-column>
            </el-table>
            <!-- <div
              class="content-container"
              v-if="
                alarmDetail.deviceType == '27' ||
                alarmDetail.deviceType == '28' ||
                alarmDetail.deviceType == '29'
              "
              style="line-height: 40px; margin: 10px 0 20px"
            >
              <el-row>
                <el-col :span="24" style="text-align: center; margin: 5px 0px">
                  <el-button type="primary" @click="handleMain">操作消防主机 </el-button>
                </el-col>
              </el-row>
            </div> -->
          </div>

          <div class="detail-div" v-if="activeName === 1">
            <div v-if="alarmDetail.alarmState == 4 || alarmDetail.alarmState == 10">
              <div class="detail-item" v-if="workerOrderList.length > 0">
                <el-scrollbar height="90%">
                  <el-timeline style="padding: 10px" class="timeLine">
                    <el-timeline-item v-for="(activity, index) in workerOrderList" :key="index" placement="top" :timestamp="activity.operateTime | moment">
                      <p class="action">
                        {{ $t("taskCenter.label.action") }}
                        {{ formatter(execute, activity.action) }}
                      </p>
                      <p>
                        {{ $t("taskCenter.label.operator")
                        }}{{ activity.operatorName || activity.operator }}
                      </p>

                      <p>催办执行人：{{ activity.executor }}</p>
                      <p class="word-break-all">
                        {{ $t("taskCenter.label.descs") }}{{ activity.desc }}
                      </p>
                      <el-row>
                        <el-col :span="8"> 相关文件 ：</el-col>
                        <el-col :span="24" style="margin: 12px 0">
                          <app-file-list-show :fileInfoList="activity.fileInfos" @enlargeImage="enlargeImage"></app-file-list-show>
                        </el-col>
                      </el-row>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
              </div>
              <div v-else class="table-empty" style="text-align: center">
                <img src="@/common/assets/images/empty.svg" />
                <p>{{ $t("base.label.empty") }}</p>
              </div>
            </div>
            <div class="form-div" @click="handleConfirm" v-else>
              尚未派发工单，点击派单处置
            </div>
          </div>
          <div v-show="activeName === 2">
            <ioc-table ref="deviceTable" :option="deviceTableOption" :data="deviceTableData" :page="devicePage" class="deviceTable" style="height: 600px" @row-click="handleRowClick" @current-change="handleDeviceChange">
              <template slot="menu" slot-scope="scope">
                <el-button type="text" title="点击查看摄像机" v-if="scope.row.deviceMark == 18" @click="handledevice(scope.row)">
                  查看
                </el-button>
                <el-button type="text" v-if="scope.row.deviceMark != 18" @click.stop="handleDevice(scope.row)">
                  查看
                </el-button>
              </template>
            </ioc-table>
          </div>
        </div>
      </el-scrollbar>
      <!-- button 操作 -->
      <div class="btn-group">
        <el-button type="info" @click="handleClose">取消</el-button>

        <el-button @click="handleConfirmDialog" v-if="alarmDetail.alarmState == 1" type="primary">
          确认事件
        </el-button>
        <!--
        <el-button
          @click="handleUpdateFirefightingSafeEvent"
          v-if="
            alarmDetail.alarmState !== 4 &&
            alarmDetail.alarmState !== 5 &&
            activeName === 0
          "
          v-auth="'/fireAlarm:update'"
          type="primary"
        >
          确 认
        </el-button> -->
        <!--        <el-button v-auth="'/fireAlarm:update'"-->
        <!--                   v-if=" alarmDetail.alarmState !== 5 "-->
        <!--                   @click="ignoreAlarm">-->
        <!--        </el-button>-->
        <el-button type="primary" v-auth="'/fireAlarm:update'" v-if="
            alarmDetail.alarmState == 1 ||
            alarmDetail.alarmState == 6 ||
            alarmDetail.alarmState == 10
          " @click="resetDispose">
          关闭事件
        </el-button>
        <el-button @click="goPlan" v-if="planType" type="info">启动预案</el-button>

        <el-button v-if="alarmDetail.alarmState == 5" @click="handleRoute(alarmDetail.emergencyRecordCode)" type="primary">
          打开预案
        </el-button>
      </div>
    </div>
    <!-- 误报原因--忽略原因 -->
    <!--    <el-dialog :title="dialogTitle"-->
    <!--               :visible.sync="errorDialogShow"-->
    <!--               :width="'500px'"-->
    <!--               v-dialogDrag-->
    <!--               :close-on-click-modal="false"-->
    <!--               :destroy-on-close="true"-->
    <!--               :before-close="errorClose">-->
    <!--      <el-form :rules="rules"-->
    <!--               class="dialogForm"-->
    <!--               ref="dialogForm"-->
    <!--               :model="formDialog">-->
    <!--        <el-form-item label="误报原因："-->
    <!--                      prop="radio">-->
    <!--          <el-radio-group v-model="formDialog.radio"-->
    <!--                          size="mini">-->
    <!--            <el-radio label="1">环境恶劣</el-radio>-->
    <!--            <el-radio label="2">环境正常</el-radio>-->
    <!--          </el-radio-group>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="误报描述："-->
    <!--                      prop="ignoreText">-->
    <!--          <el-input type="textarea"-->
    <!--                    :rows="4"-->
    <!--                    maxlength="300"-->
    <!--                    show-word-limit-->
    <!--                    :placeholder="'请输入' + dialogText"-->
    <!--                    v-model="formDialog.ignoreText">-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <div style="margin: 15px 0 10px; color: #d0d0d0">快捷标签：</div>-->
    <!--      <div class="errorTag">-->
    <!--        <el-tag v-for="(item, index) in errorTagList"-->
    <!--                :key="index"-->
    <!--                style="margin: 10px"-->
    <!--                @click="haveTag(item.labelContent)"-->
    <!--                effect="dark">-->
    <!--          {{ item.labelName }}-->
    <!--        </el-tag>-->
    <!--        &lt;!&ndash; <el-checkbox-group v-model="ignoreTextList"-->
    <!--                           class="checkBox"-->
    <!--                           size="small">-->
    <!--          <el-checkbox v-for="(item,index) in errorTagList"-->
    <!--                       :key="index"-->
    <!--                       style="margin:10px "-->
    <!--                       :label="item"-->
    <!--                       border></el-checkbox>-->
    <!--        </el-checkbox-group> &ndash;&gt;-->
    <!--      </div>-->
    <!--      <div slot="footer"-->
    <!--           class="dialog-footer">-->
    <!--        <el-button @click="errorClose">取消</el-button>-->
    <!--        <el-button type="primary"-->
    <!--                   @click="errorSubmit">确定-->
    <!--        </el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <!-- 误报原因--忽略原因 -->
    <el-dialog :title="dialogTitle" :visible.sync="errorDialogShow" width="550px" append-to-body :before-close="errorClose">
      <el-form :rules="rules" class="dialogForm" ref="dialogForm" :model="formDialog">
        <el-form-item label="事件确认" prop="confirmType">
          <el-radio-group v-model="formDialog.confirmType" v-if="!isMerge">
            <el-radio :label="1" v-if="alarmDetail.alarmState === 6 || alarmDetail.alarmState === 10">处理完成</el-radio>
            <el-radio :label="2" text-color="red" v-if="alarmDetail.alarmState === 1">误报事件</el-radio>
          </el-radio-group>
          <el-radio-group v-model="formDialog.confirmType" v-if="isMerge">
            <el-radio text-color="red" :label="2">误报事件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注说明" prop="processDesc">
          <el-input type="textarea" :rows="3" maxlength="200" show-word-limit :placeholder="'请输入备注说明'" v-model="formDialog.processDesc">
          </el-input>
        </el-form-item>
        <el-form-item label="快捷标签" v-if="formDialog.confirmType === 2">
          <div class="errorTag">
            <el-tag v-for="(item, index) in errorTagList" :key="index" style="margin: 10px" @click="haveTag(item.labelContent)" effect="dark">
              {{ item.labelName }}
            </el-tag>
            <!-- <el-checkbox-group v-model="ignoreTextList"
                               class="checkBox"
                               size="small">
              <el-checkbox v-for="(item,index) in errorTagList"
                           :key="index"
                           style="margin:10px "
                           :label="item"
                           border></el-checkbox>
            </el-checkbox-group> -->
          </div>
        </el-form-item>
      </el-form>
      <div style="line-height: 25px; padding: 5px; color: #c1c1c1">
        提示： 事件结束后不允许再处理，事件和工单处理记录可在事件档案中查看
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="errorClose">取消</el-button>
        <el-button type="primary" @click="errorSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 确定回调left 弹窗 -->
    <div :class="['fire-detail-container', taskPanelVisible ? 'show' : '']" style="background-color: #fff">
      <div class="ioc-drawer__header" style="padding: 12px; background-color: rgb(234, 243, 253)">
        <div class="slot-title" :title="'【' + alarmDetail.subSystemLabel + '】' + alarmDetail.alarmName">
          {{ "【" + alarmDetail.subSystemLabel + "】" + alarmDetail.alarmName }}
        </div>
      </div>
      <el-scrollbar class="flex-auto container__scrollbar">
        <div class="content-container">
          <el-row v-if="!rowClick.alarmId">
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                告警时间：{{ formatterTimeCopy(alarmDetail.alarmTime) | moment }}
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                告警级别：{{ alarmDetail.alarmLevel | dic("SENU017") }}
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">任务描述：</div>
              <el-input type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入任务描述" v-model="taskDesc">
              </el-input>
              <div class="errorTag">
                <!-- <div style="color:#D0D0D0">快捷标签：</div>
                <el-tag v-for="item in DescTagList"
                        :key="item"
                        style="margin:10px "
                        class="checkBox"
                        @click="haveTag2(item)"
                        effect="dark">
                  {{ item }}
                </el-tag> -->
                <!-- <el-checkbox-group v-model="taskDescList"
                                   class="checkBox"
                                   size="small">
                  <el-checkbox v-for="(item,index) in DescTagList"
                               :key="index"
                               style="margin:10px "
                               :label="item"
                               border></el-checkbox>
                </el-checkbox-group> -->
              </div>
            </el-col>
            <el-col :span="24">
              <span style="margin-right: 5px">执行人员：</span>
              <!--              <span>-->
              <!--                <span type="text" style="font-size: 14px; cursor: pointer;" class="el-icon-circle-plus-outline" @click="handleAddPeople"> 添加</span>-->
              <!--                <span class="tip" v-if="showTip" style="font-size: 12px; color: #f56c6c; margin-left: 12px">*请添加执行人员</span>-->
              <!--              </span>-->
              <!-- <div style=" display: flex;justify-content: flex-end;"> -->
              <!--              <span-->
              <!--                v-if="taskType == 2"-->
              <!--                type="text"-->
              <!--                style="font-size: 14px; cursor: pointer"-->
              <!--                class="el-icon-circle-plus-outline"-->
              <!--                @click="addSafty"-->
              <!--              >-->
              <!--                添加安全员</span-->
              <!--              >-->
              <span type="text" style="margin-left: 12px; font-size: 14px; cursor: pointer" class="el-icon-circle-plus-outline" @click="addWorkGroup">
                添加执行组</span>
              <!-- <el-button v-if="taskType == 2" type="text" class="add-btn" @click="addSafty">添加安全员</el-button> -->
              <!-- <el-button type="text" class="add-btn" @click="addWorkGroup">添加执行组</el-button> -->
              <!-- </div> -->
            </el-col>
            <el-col :span="24">
              <alarmTask :alarm="alarmDetail" @taskSuccess="taskSuccess" @deleteWorker="deleteWorker" @getDesc="getDesc" @goLast="goLast" @goPlan="goPlan" :taskType="taskType" :planType="planType" ref="alarmTask" />
            </el-col>
          </el-row>
        </div>
      </el-scrollbar>
      <div class="btn-group" style="background-color: #eaf3fd">
        <el-button type="info" @click="goLast">取消</el-button>
        <el-button type="info" @click="handleAddTaskInfo">立即派发</el-button>
        <!-- <el-button @click="goPlan" v-if="planType" type="primary"
          >启动预案</el-button
        > -->
      </div>
    </div>

    <el-dialog :title="$t('realTimeAlarm.title.resourse')" :visible.sync="resourceDialogShow" width="540px " v-dialogDrag :close-on-click-modal="false" :destroy-on-close="true" :before-close="resourceClose">
      <!-- 该行数据currentResource，告警详情taskAlarmInfo都必须有 -->
      <resource-show ref="resourceDialog" :resourceUrl="currentResource" :alarmInfo="alarmDetail" />
    </el-dialog>

    <!-- 选择预案流程 -->
    <el-dialog class="ioc-alarm__warp" :visible="showSelect" width="560px" :before-close="handleCloseSelect" custom-class="plan-list-select" :title="$t('reserveImplement.label.reserveSelect')">
      <div>* 根据预案类型选择预案流程</div>
      <div class="select-content" style="height: 380px; justify-content: space-between">
        <el-scrollbar class="scroll-bar diaBk" style="margin: 12px 12px 0 0">
          <div class="title">预案类型</div>
          <div class="list">
            <div v-for="(item, i) in planList" :key="i" :title="item.label" :class="[
                'item show-ellipsis',
                item.value == selectType.value ? 'current' : '',
              ]" @click="getReserveList(item)">
              {{ item.label }}
            </div>
          </div>
        </el-scrollbar>
        <el-scrollbar class="scroll-bar diaBk" style="margin: 12px 0px 0 0">
          <div class="title">预案流程配置</div>
          <div v-show="currentSubList.length" class="list">
            <div v-for="(cur, j) in currentSubList" :key="j" :title="showLevelName(cur)" :class="['item show-ellipsis ', j === currentSubIndex ? 'current' : '']" @click="chooseReserve(j)">
              {{ showLevelName(cur) }}
            </div>
          </div>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseSelect" type="info" :loading="btnLoading">{{
          btnLoading ? "提交中" : $t("base.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="handleConfirmSelect" :loading="btnLoading">{{
          btnLoading ? "提交中" : $t("base.button.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
import alarmTask from "../../realTimeAlarm/components/alarmTask";
import appFileListShow from "@src/components/business/app-file-list-show";
import resourceShow from "@src/components/business/app-resource-show-alarm";
import utils from "@src/common/utils";

export default {
  components: {
    alarmTask,
    resourceShow,
    appFileListShow,
  },
  props: {
    alarmDetail: {
      type: Object,
      default: {},
    },
    workerOrderList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rowClick: {
      type: Object,
      default: {},
    },
    rowLoopText: {
      type: String,
      default: "",
    },
    rowAddressText: {
      type: String,
      default: "",
    },
    relationList: {
      type: Array,
      default: [],
    },
    securityPersonnel: {
      type: String,
      default: "",
    },
    alternatePersonnel: {
      type: String,
      default: "",
    },
    buildingPerson: {
      type: String,
      default: "",
    },
  },
  watch: {
    "alarmDetail.alarmState": {
      handler(newValue, oldValue) {
        if (newValue == 6 || newValue == 10) {
          this.formDialog.confirmType = 1;
        } else if (newValue == 1 || newValue == 4) {
          this.formDialog.confirmType = 2;
        }
        // console.log(newValue, oldValue, "=================oldVal");
      },
    },
  },
  data() {
    return {
      btnLoading: false,
      showSelect: false,
      planList: [], //预案类型列表
      selectType: {}, //当前选择预案类型
      currentSubIndex: -1, //当前所选预案下标
      currentSubList: [], //当前类型的预案列表
      showTip: false,
      execute: Dic.find("SENU056"), // 执行动作
      currentResource: [],
      resourceDialogShow: false,
      tabs: [
        { name: "事件详情", value: 0 },
        { name: "处置工单", value: 1 },
        { name: "关联设备", value: 2 },
      ],
      activeName: 0,
      devicePage: {
        countPage: 5,
        pageSize: 30,
        currentPage: 1,
        total: 0,
        layout: " prev, pager, next",
      },
      deviceTableOption: {
        index: false,
        indexLabel: "序号",
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        align: "left",
        size: "small",
        menuWidth: 80,
        labelWidth: "100",
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        emptyText: "暂无数据",
        column: [
          {
            label: "设备类型",
            prop: "deviceMark",
            editDisabled: false,
            formatter: function (row, value) {
              return value ? Dic.findByValue("SENU087", value) : "";
            },
          },
          {
            label: "设备名称",
            prop: "deviceName",
            editDisabled: false,
          },
          {
            label: "位置",
            prop: "distance",
            editDisabled: false,
          },
        ],
      },
      deviceTableData: [],
      isdeviceExpand: false,
      editDescInfo: "",
      isExpand: false,
      taskType: "2",
      planType: false,
      resetErrorType: "",
      dialogVisible: false,
      drawLoading: true,
      dialogTitle: "",
      dialogText: "",
      taskPanelVisible: false,
      errorDialogShow: false,
      taskDesc: "",
      taskDescList: [],
      ignoreTextList: [],
      formDialog: {
        confirmType: 2,
        ignoreText: "",
        processDesc: "",
      },
      isMerge: false,
      alarmMergeFlag: "0",
      errorTagList: [
        "入蒸汽较大",
        "粉尘较大",
        "光线太强",
        "窗户过近",
        "距离空调通风口太近",
        "其他输入原因",
      ],
      errorTagFireList: [
        "动火",
        "火灾",
        "光线过强（紫外线探测器）",
        "光线遮挡（红外式）",
        "蒸汽较大",
        "粉尘较大",
        "距离通风口过近",
        "熏蒸消毒",
        "设备老化",
        "原因尚不明确",
        "功能测试",
      ],
      errorTagFaultList: [
        "泡水",
        "电磁干扰",
        "短路",
        "接地",
        "违规改造",
        "设备老化",
        "系统故障",
        "熏蒸消毒",
        "原因尚不明确",
        "功能测试",
      ],
      DescTagList: [
        "请车间做好除尘等",
        "请更改设备位置",
        "请更换合适设备并修改设备类型",
      ],
      alarm: {
        alarmId: "",
        processDesc: "",
        alarmState: "",
      },
      rules: {
        confirmType: [{ required: true, message: "请选择", trigger: "change" }],
        ignoreText: [
          { required: false, message: "请输入原因", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    // Dic.find("SENU073005").forEach((item) => {
    //   item.value = item.value + "";
    //   this.planList.push(item);
    // });
  },
  beforeDestroy() {},
  methods: {
    chooseReserve(index) {
      this.currentSubIndex = index;
    },
    handleCloseSelect() {
      this.currentSubIndex = -1;
      this.showSelect = false;
    },
    handleConfirmSelect() {
      if (this.currentSubIndex == -1) {
        this.$message.warning("请选择预案后启动预案");
        return;
      }
      const params = {
        alarmDevId: this.alarmDetail.alarmDevId,
        alarmId: this.alarmDetail.alarmId,
        alarmType: this.alarmDetail.alarmType,
        latitude: this.alarmDetail.lat,
        longitude: this.alarmDetail.lng,
        status: "1",
        emergencyPlanCode:
          this.currentSubList[this.currentSubIndex].emergencyPlanCode, //预案流程id
      };
      this.btnLoading = true;
      this.$fetch(api.alarm.startEmergency, params).then((response) => {
        this.btnLoading = false;
        if (response.success) {
          this.handleCloseSelect();
          this.$message.success("预案启动成功");
          this.$emit("refreshList");
          this.handleRoute(response.returnObj);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    showLevelName(cur) {
      // return `${cur.emergencyPlanName}    ${cur.levelName}`;
      return `${cur.emergencyPlanName}`;
    },
    // 根据预类型获取预案流程
    getReserveList(row) {
      this.selectType = row;
      let params = {
        pageNum: 1,
        pageSize: 1000,
        status: "1",
        subSystemList: [row.value],
      };
      this.$fetch(api.getEmergencyPlanListByAlarmType, params).then(
        (response) => {
          if (response.success) {
            this.currentSubIndex = -1;
            this.currentSubList = response.returnObj.list.map((item) => {
              if (item.levelName) {
                return item;
              }
              item.levelName = Dic.findByValue("SENU073002", item.level);
              return item;
            });
          } else {
            this.$message({
              type: "error",
              message: response.msgContent,
            });
          }
        }
      );
    },
    resetDispose() {
      this.disposeType = "alarm";
      this.dialogTitle = "事件结束确认";
      this.errorDialogShow = true;
      this.isMerge = false;
      let params = {
        refCode: this.alarmDetail.alarmType,
        serviceType: "1",
      };
      this.$fetch(api.alarm.queryQuickLabelList, params).then((response) => {
        if (response && response.success) {
          if (response.returnObj) {
            this.errorTagList = [];
            response.returnObj.forEach((item) => {
              this.errorTagList.push(item);
            });
          }
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    addSafty() {
      this.$refs.alarmTask.addSafty();
    },
    addWorkGroup() {
      this.$refs.alarmTask.addWorkGroup();
    },
    handleCloseReportPanel() {
      this.showReportPanel = false;
      this.reportForm.remark = "";
      this.executeTeams = [];
      this.showTip = false;
      this.executeIdTeams = [];
      this.reportForm.executeTeams[0].executor = [];
      this.reportForm.executeTeams[0].executorName = [];
      this.reportForm.executeTeams[0].accountType = [];
      this.$refs.alarmTask.executeTeams = [];
    },
    handleAddPeople() {
      this.$refs.alarmTask.addWorkGroup();
    },
    alarmType(val) {
      return Dic.findByValue("SENU100", Number(val));
    },
    alarmLevel(val) {
      return Dic.findByValue("SENU017", val);
    },
    // 资源组件关闭
    resourceClose() {
      this.$refs.resourceDialog.stopVideo();
      this.resourceDialogShow = false;
    },
    enlargeImage(item) {
      this.resourceDialogShow = true;
      this.currentResource = [item];
    },
    handleReport() {
      this.taskPanelVisible = true;
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    handleTabsChange(item) {
      this.activeName = item.value;
    },
    // 跳转进入预案
    handleRoute(emergencyRecordCode = "") {
      this.$router.push({
        path: "/reserve/reserveProcess",
        query: {
          emergencyRecordCode: emergencyRecordCode,
        },
      });
    },
    // 点击设备callback
    handleRowClick(item) {
      this.$emit("tableActionPosition", item);
    },
    // 播放视频
    handledevice(item) {
      this.$emit("tableActionPlay", item);
    },
    //定位操作
    handleDevice(item) {
      this.$emit("tableActionPosition", item);
    },
    // 初始化请求数据
    getData(item) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 20;
      this.devicePage.total = 0;
      this.deviceTableData = [];
      this.getDeviceDistance(item);
    },
    // 设备周边摄像机分页
    handleDeviceChange(val) {
      this.devicePage.currentPage = val;
      this.getDeviceDistance(this.alarmDetail);
    },
    // 查询设备周边摄像机列表
    getDeviceDistance(item) {
      this.$fetch(api.alarm.queryFirefightingAlarmDeviceList, {
        pageNum: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        alarmId: item.alarmId,
      }).then((response) => {
        if (response && response.success) {
          this.deviceTableData = response.returnObj.list || [];
          this.devicePage.total = response.returnObj.total;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    setDescInfo(data) {
      this.editDescInfo = data;
    },
    showColor(val) {
      if (val == "4001") {
        return "colorRed";
      } else if (val == "4002") {
        return "colorYellow";
      } else if (
        val == "4005" ||
        val == "4008" ||
        val == "4009" ||
        val == "40099"
      ) {
        return "colorBlue";
      } else if (val == "130103") {
        return "colorYellow";
      } else if (val == "130101") {
        return "colorRed";
      } else {
        return "";
      }
    },
    alarmColor(level) {
      let className = "";
      if (level === 1) {
        className = "instancys";
      }
      if (level === 2) {
        className = "severitys";
      }
      if (level === 3) {
        className = "generals";
      }
      if (level === 4) {
        className = "commons";
      }
      return className;
    },
    getDesc() {
      // this.$refs.alarmTask.task.desc = this.taskDescList.toString()
      this.$refs.alarmTask.task.desc = this.taskDesc;
    },
    handleAddTaskInfo() {
      this.$refs.alarmTask.addTaskInfo();
    },
    // 返回上一级
    goLast() {
      this.taskPanelVisible = false;
      this.dialogVisible = true;
    },
    // 进入预案执行
    goPlan() {
      this.showSelect = true;
      // const params = {
      //   alarmDevId: this.alarmDetail.alarmDevId,
      //   alarmId: this.alarmDetail.alarmId,
      //   alarmType: this.alarmDetail.alarmType,
      //   latitude: this.alarmDetail.lat,
      //   longitude: this.alarmDetail.lng,
      //   status: "1",
      // };
      // this.$fetch(api.alarm.startEmergency, params).then((response) => {
      //   if (response.success) {
      //     this.$message.success("预案启动成功");
      //     this.handleRoute(response.returnObj);
      //   } else {
      //     this.$message.error(response.msgContent);
      //   }
      // });
    },
    deleteWorker(id) {
      // if (this.executeTeams.indexOf(id) != -1) {
      //   this.executeTeams.splice(this.executeTeams.indexOf(id), 1)
      // }
    },
    //
    taskSuccess(id) {
      this.taskPanelVisible = false;
      this.dialogVisible = false;
      this.$emit("refreshList");
    },
    handleConfirmDialog() {
      this.$confirm("确认火警信息后将发送通知，是否确认事件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleConfirmEvent();
        })
        .catch(() => {
          // console.log("取消操作");
        });
    },
    // 事件确认
    handleConfirmEvent() {
      let params = {
        alarmId: this.alarmDetail.alarmId,
      };
      this.$fetch(api.alarm.confirmFirefightingSafeEvent, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
          } else {
            this.$emit("refreshList");
            this.$message.success("事件确认成功");
          }
        }
      );
    },
    handleUpdateFirefightingSafeEvent() {
      // 修改基本信息中的告警描述字段
      let params = {
        alarmId: this.alarmDetail.alarmId,
        desc: this.editDescInfo,
      };
      this.$fetch(api.alarm.updateFirefightingSafeEvent, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
          } else {
            this.$message.success("修改告警描述成功！");
          }
        }
      );
    },
    // 确认按钮
    handleConfirm() {
      // console.log(this.alarmDetail)
      if (this.alarmDetail.commonAlarmType == "4001") {
        this.$fetch("cms/workgroup/querySecurityInfoByArea.json", {
          groupCode: this.alarmDetail.groupCode,
          // groupCode: "20200615000047",
        }).then((res) => {
          if (res.success && res.returnObj) {
            let tempArr = [];
            tempArr = res.returnObj;
            this.checkedList = tempArr.map((data) => {
              return data.accountNumber;
            });
            this.chiocedPersonArr = tempArr.map((data) => {
              return {
                id: data.accountNumber,
                name: data.nickName,
              };
            });
            this.$nextTick(() => {
              this.$refs.alarmTask.executeTeams =
                this.$refs.alarmTask.executeTeams.concat(this.chiocedPersonArr);
              var temp = [];

              this.$refs.alarmTask.executeTeams.forEach(function (a) {
                var check = temp.every(function (b) {
                  return a.id !== b.id;
                });
                check ? temp.push(a) : "";
              });
              this.$refs.alarmTask.executeTeams = temp;
              // this.$refs.alarmTask.executeTeams.forEach((res) => {
              //   var check = this.chiocedPersonArr.every((data) => {
              //     return res.id !== data.id;
              //   });
              //   check ? this.chiocedPersonArr.push(res) : "";
              // });
            });
          }
        });
      }

      this.taskPanelVisible = true;
      // this.taskDescList = [];
      // this.taskDesc = [];
      this.dialogVisible = false;
    },
    // 操作主机按钮
    handleMain() {
      this.$emit("handleMain");
    },
    showDetailDialog(data) {
      // console.log(data)
      this.planType = false;
      this.dialogVisible = true;
      this.resetErrorType = data.alarmMergeCode;
      this.alarmMergeFlag = data.alarmMergeFlag;
      this.drawLoading = false;
      // 默认消防子系统的部件火警和主机火警才会触发预案启动
      this.planList = [];
      // 一键求救12，火灾4，有毒有害气体13
      Dic.find("SENU073005").forEach((item) => {
        if (
          item.value == data.subSystem &&
          data.alarmState == 1 &&
          (data.alarmType == "40116" || data.alarmType == "40102")
        ) {
          this.planType = true;
          item.value = item.value + "";
          this.planList.push(item);
          this.getReserveList(item);
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.taskPanelVisible = false;
      this.$emit("handleClose");
    },
    // 当为“处理”，则进入到设备控制页面
    handleAlarm() {
      // 如果是部件设备告警跳转到控制页面需要传主机设备ID
      // if (this.alarmDetail.subDeviceMark !== null) {
      //   this.$router.push({
      //     path: '/fireManage',
      //     name: 'fireManage',
      //     query: { id: this.alarmDetail.parentDeviceId }
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/fireManage',
      //     name: 'fireManage',
      //     query: { id: this.alarmDetail.alarmDevId }
      //   })
      // }
      let newMsg = window.location.href.split("#")[0];
      window.open(
        newMsg +
          "#/fireManage?id=" +
          this.alarmDetail.alarmDevId +
          "&alarmType=" +
          this.alarmDetail.alarmType +
          "&alarmFire=" +
          (this.alarmDetail.alarmId + "-" + this.alarmDetail.alarmState)
      );

      // this.$router.push({
      //   path: "/fireManage",
      //   name: "fireManage",
      //   query: {
      //     id: this.alarmDetail.alarmDevId,
      //     alarmType: this.alarmDetail.alarmType,
      //     alarmFire:
      //       this.alarmDetail.alarmId + "-" + this.alarmDetail.alarmState,
      //   },
      // });
    },
    // 表格行点击事件
    alarmRowClick(row) {
      this.$emit("rowDetail", row.alarmId);
    },
    // 获取告警详情
    getAlarmDetails(id) {
      let params = {
        alarmId: id,
      };
      this.$fetch(api.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.alarmDetail = response.returnObj;
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    //时间格式化
    formatterTime(row) {
      return utils.Dates.dayjs(row.alarmTime).format("YYYY-MM-DD HH:mm:ss");
    },
    //时间格式化
    formatterTimeCopy(val) {
      return utils.Dates.dayjs(val).format("YYYY-MM-DD HH:mm:ss");
    },
    ignoreAlarm() {
      this.dialogTitle = "误报";
      this.dialogText = "误报描述：";
      this.errorDialogShow = true;
      this.formDialog.ignoreText = this.alarm.processDesc;
      this.alarmMergeFlag = null;
      // console.log(this.alarm, "0000alarm");
      let params = {
        refCode: this.alarmDetail.alarmType,
        serviceType: "1",
      };
      this.$fetch(api.alarm.queryQuickLabelList, params).then((response) => {
        if (response && response.success) {
          if (response.returnObj) {
            this.errorTagList = [];
            response.returnObj.forEach((item) => {
              this.errorTagList.push(item);
            });
          }
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    // 误报处理
    ignoreAlarmAll(val) {
      // console.log(val, "00000000000000111");
      this.dialogTitle = "误报";
      this.dialogText = "误报原因：";
      this.errorDialogShow = true;
      this.resetErrorType = val.alarmMergeCode;
      this.alarmMergeFlag = val.alarmMergeFlag;
      let params = {
        refCode: this.alarmDetail.alarmType,
        serviceType: "1",
      };
      this.$fetch(api.alarm.queryQuickLabelList, params).then((response) => {
        if (response && response.success) {
          if (response.returnObj) {
            this.errorTagList = [];
            response.returnObj.forEach((item) => {
              this.errorTagList.push(item);
            });
          }
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    haveTag(item) {
      // this.formDialog.ignoreText = this.formDialog.ignoreText
      this.formDialog.processDesc = this.formDialog.processDesc
        ? this.formDialog.processDesc + "," + item
        : this.formDialog.processDesc + item;
    },
    haveTag2(item) {
      this.taskDesc = this.taskDesc
        ? this.taskDesc + "," + item
        : this.taskDesc + item;
    },
    // 误报弹框取消按钮
    errorClose() {
      this.alarm.processDesc = "";
      this.$refs.dialogForm.resetFields();
      this.errorDialogShow = false;
    },
    // 误报弹框确认按钮
    errorSubmit() {
      this.$refs.dialogForm.validate((res) => {
        if (res) {
          this.alarm.processDesc = this.formDialog.processDesc;
          this.formDialog.confirmType == 1
            ? this.alarmDispose(2, this.$t("realTimeAlarm.message.confirmSuc"))
            : this.missReport();
        }
      });
    },
    alarmDispose(state, msg) {
      if (
        this.alarmDetail != null &&
        this.alarmDetail.hasOwnProperty("alarmId")
      ) {
        this.alarm.alarmId = this.alarmDetail.alarmId;
      }
      this.alarm.alarmState = state;
      this.$fetch(api.alarm.updateAlarm, this.alarm).then((response) => {
        if (response && response.success) {
          this.errorClose();
          this.dialogVisible = false;
          this.$emit("refreshList");
          this.$message.success(msg);
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    missReport() {
      this.alarm.alarmId = this.alarmDetail.alarmId;
      this.alarm.alarmState = 3;
      if (this.isMerge) {
        // 批量误报
        let params = {
          processDesc: this.alarm.processDesc,
          alarmLevel: this.$parent.queryParams.alarmLevel,
          alarmTypeList: this.$parent.queryParams.alarmTypeList,
          alarmMergeCode: this.resetErrorType,
          alarmMergeFlag: this.alarmMergeFlag,
          subSystemList: this.$parent.queryParams.subSystemList,
          alarmName: this.$parent.queryParams.deviceName,
          alarmStartTime: this.$parent.queryParams.alarmStartTime,
          alarmEndTime: this.$parent.queryParams.alarmEndTime,
        };
        this.$fetch(api.alarm.batchMissReport, params).then((response) => {
          if (response && response.success) {
            this.errorClose();
            this.dialogVisible = false;
            this.$emit("refreshList");
            this.$message.success("误报提交成功");
          } else {
            response.msgContent && this.$message.error(response.msgContent);
          }
        });
        return;
      }
      this.$fetch(api.alarm.missReport, this.alarm).then((response) => {
        if (response && response.success) {
          this.errorClose();
          this.dialogVisible = false;
          this.$emit("refreshList");
          this.$message.success("误报提交成功");
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.checkBox {
  .el-checkbox {
    padding: 5px 6px 5px 0px !important;
    height: 30px !important;

    .el-checkbox__input {
      .el-checkbox__inner {
        display: none !important;
      }
    }
  }
}

.deviceTable {
  .ioc-table__search {
    margin-top: 0 !important;
    padding: 0;
  }

  .ioc-table__content {
    padding: 0;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.timeLine {
  .el-timeline-item__timestamp {
    // color: #ffffff;
  }

  .el-timeline-item__content {
    // color: #ffffff;

    p {
      margin: 12px 0;
    }

    .action {
      position: absolute;
      top: -12px;
      background: #407aee;
      color: #fff;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }

  :deep .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
}

.fire-detail-container {
  position: absolute;
  right: -360px;
  top: 0px;
  z-index: 5;
  width: 360px;
  height: calc(100% - 0px);
  background-color: rgba(11, 18, 35, 0.35);
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  transition: right 0.3s;

  &.show {
    right: 0px;
  }

  .container__header {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    padding: 15px 0 15px 15px;
  }

  .container__scrollbar {
    flex: 1;
    height: 0;

    &__content {
      display: flex;
      flex-direction: column;
      padding: 13px 10px;
      // background: rgba(24, 31, 46, 0.65);
      @include set_theme_color(background-color, map-item-color);
      margin: 0 10px 10px;

      .tab {
        flex: 1;
        font-weight: bold;
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 4px solid rgba(64, 122, 238, 0.2);

        &:hover {
          color: #407aee;
          cursor: pointer;
        }

        &.active {
          color: #407aee;
          border-color: #407aee;
        }
      }

      .content-list {
        display: flex;
        flex-direction: column;

        &__item {
          display: flex;
          line-height: 26px;
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        &__label {
          width: 100px;
          text-align: right;
          vertical-align: middle;
          font-size: 14px;
          // color: #dddddd;
          padding-right: 12px;
        }

        &__value {
          flex: 1;
        }
      }

      .detail-div,
      .device-content {
        width: 100%;

        .form-div {
          cursor: pointer;
          margin: 50px;
          padding: 10px;
          border-radius: 5px;
          text-align: center;
          border: 1px solid rgba(193, 193, 193, 0.65);

          &:hover {
            color: #407aee;
            border-color: #407aee;
          }
        }

        .btnBox {
          display: flex;
          justify-content: space-between;

          button {
            font-size: 16px;
          }
        }
      }

      .timeLine {
        .el-timeline-item__timestamp {
          // color: #ffffff;
        }

        .el-timeline-item__content {
          //color: #ffffff;

          p {
            margin: 12px 0;
          }

          .action {
            position: absolute;
            top: -12px;
            background: #407aee;
            color: #fff;
            padding: 4px 8px;
            border-radius: 5px;
          }
        }

        :deep .el-timeline-item__node {
          box-shadow: 0px 0px 5px 4px #407aee;
        }
      }
    }
  }
  .slot-title {
    max-width: 95%;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
    overflow: hidden;
    font-size: 16px;
    padding: 5px 0 0px 0px;
  }
  .map-blur-panel__title {
    @include set_theme_color(background-color, blur-color);
    display: flex;
    opacity: 0.8;
    flex-direction: row;
    justify-content: space-between;

    .ioc-drawer__close {
      cursor: pointer;
    }
  }

  .container__scrollbar {
    .alarm-title {
      // color: #b3cbf1;
      margin-bottom: 10px;
      font-size: 16px;
      padding: 0 15px;
      padding-top: 10px;
    }

    .content-container {
      margin: 12px;
      padding: 0 10px;
      line-height: 36px;
      opacity: 1;
      // background: rgba(24, 31, 46, 0.65);
      // @include set_theme_color(background-color, map-panel-content);
    }
  }

  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 16px 0;
    //margin: 16px 0;
  }

  .el-table__row {
    // cursor: pointer;
  }
}
.diaBk {
  // background-color: #0d121c;
  @include set_theme_color(background-color, page-default-bg);
  .title {
    height: 32px;
    line-height: 32px;
    text-align: center;
    @include set_theme_color(background-color, input-disabled-bg-color);
  }
  .item {
    border-bottom: 1px solid #fff;
    &:hover {
      @include set_theme_color(background-color, input-disabled-bg-color);
    }
  }
  .current {
    @include set_theme_color(background-color, input-disabled-bg-color);
  }
}
.el-tag {
  &:hover {
    cursor: pointer;
  }
}

.colorRed {
  color: red !important;
}

.colorYellow {
  color: rgb(255, 191, 1) !important;
}

.colorBlue {
  color: #409eff !important;
}

.instancys {
  color: #ff4547;
}

.severitys {
  color: #ff466e;
}

.generals {
  color: #ffbf00;
}

.commons {
  color: #2a65ff;
}

.allLevels {
  color: #97dbf1;
}

.icon-transform {
  transform: rotate(180deg);
}
</style>
